module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 512 512\"><path d=\"M232 235h48v137h-48zM232 140h48v48h-48z\"></path></svg>"